module.exports = __webpack_public_path__ + "static/img/ms23.62b0acf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ms23.png
// module id = lL6f
// module chunks = 73